import React from 'react';
import parse from 'html-react-parser';

const ReviewComment = (props) => {
    return (
        <div style={{ textAlign: 'left', lineHeight: '1.5', fontSize: '14px', color: '#292929' }}>
            {parse(props.comment)}
        </div>
    );
};

export default ReviewComment;